<template>
  <search-comp @onSearch="onSearch" @onReset="onReset">
    <template>
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Danh mục</div>
                <VxTreeSelect
                  :options-tree="optionsTree"
                  :parent-data="searchParams.productPortFolioID"
                  @valueChange="dialogTreeDataChange"
                />
                <!-- <el-select
                  v-model="searchParams.productPortFolioID"
                  placeholder=""
                >
                  <el-option :value="null" label="Chọn" />
                  <el-option
                    v-for="item in productCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select> -->
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã/Tên SP</div>
                <div class="child-w-80">
                  <input v-model="searchParams.productKeyWord" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>
                <el-select v-model="searchParams.isStop" placeholder="">
                  <el-option :value="null" label="Chọn" />
                  <el-option :value="false" label="Hoạt động" />
                  <el-option :value="true" label="Không hoạt động" />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Đơn vị</div>
                <el-select
                  v-model="searchParams.productCalUnitId"
                  placeholder=""
                >
                  <el-option :value="null" label="Chọn" />
                  <el-option
                    v-for="item in productCalOptions"
                    :key="item.id"
                    :label="item.unit"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Điểm bán</div>
                <el-select
                  v-model="searchParams.businessDistrictId"
                  placeholder=""
                >
                  <el-option :value="null" label="Chọn" />
                  <el-option
                    v-for="item in businessDistrictOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Loại</div>
                <el-select v-model="searchParams.type" placeholder="">
                  <el-option :value="null" label="Chọn" />
                  <el-option
                    v-for="item in productTypeOptions"
                    :key="item.id"
                    :label="item.desc"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </search-comp>
</template>
<script>
import VxTreeSelect from '@/components/ui/VxTreeSelect.vue'
import { getListProductType } from '@/api/common/code_base'
import { getListProductCategoryApi } from '@/api/configuration/accounting/product/productCategory.js'
import { getListProductUnitApi } from '@/api/configuration/accounting/product/unit.js'
export default {
  components: { VxTreeSelect },
  data() {
    return {
      searchParams: {
        pageNum: 1,
        productPortFolioID: null,
        productKeyWord: null,
        isStop: null,
        productCalUnitId: null,
        businessDistrictId: null,
        type: null
      },
      productTypeOptions: [],
      productCalOptions: [],
      productCategoryOptions: [],
      businessDistrictOptions: [],
      optionsTree: [],
      dfOptionsTree: []
    }
  },
  async mounted() {
    const data1 = await getListProductType()
    const data2 = await getListProductCategoryApi()
    const data3 = await getListProductUnitApi({ showNotActive: true })
    this.productTypeOptions = data1.data
    this.productCategoryOptions = data2.data
    this.productCalOptions = data3.data
    await this.getBusinessDistrictOptions()
    this.onSearch()
    // aaaaaaaaaaaaa
    this.dfOptionsTree = this.changeKeyNames(data2.data)
    Object.assign(this.optionsTree, this.dfOptionsTree)
    this.optionsTree = JSON.parse(JSON.stringify(this.dfOptionsTree))
  },
  methods: {
    changeKeyNames(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.changeKeyNames(item))
      }

      // If the object is an object, iterate over its key-value pairs
      const newObj = {}
      for (const key in obj) {
        // Change the key from 'code' to 'label'
        const newKey = key === 'code' ? 'label' : key
        const newKey1 = key === 'main_category_id' ? 'id' : key
        // Change the key from 'sub_transactions' to 'children'
        // Recursively process the value
        newObj[newKey] = this.changeKeyNames(obj[key])
        newObj[newKey1] = this.changeKeyNames(obj[key])
      }
      return newObj
    },
    dialogTreeDataChange(data) {
      this.searchParams.productPortFolioID = data
    },
    async getBusinessDistrictOptions() {
      // businessDistrictOptions
      await this.$axios
        .get('/config-service/v1/business-district/list-simple')
        .then(res => {
          this.businessDistrictOptions = res.data
        })
    },
    onSearch() {
      this.$emit('onSearch', this.searchParams)
    },
    onReset() {
      this.searchParams = {
        pageNum: 1,
        productPortFolioID: null,
        productKeyWord: null,
        isStop: null,
        productCalUnitId: null,
        businessDistrictId: null,
        type: null
      }
      this.$emit('onReset', this.searchParams)
    }
  }
}
</script>
